export default __webpack_public_path__ + "static/media/countdown.c5899e8e.mp3";